import { render, staticRenderFns } from "./PersonProfileAssociatedRecordsRow.vue?vue&type=template&id=17618a91&scoped=true&"
import script from "./PersonProfileAssociatedRecordsRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfileAssociatedRecordsRow.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileAssociatedRecordsRow.vue?vue&type=style&index=0&id=17618a91&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17618a91",
  null
  
)

export default component.exports